import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { sanitizeDialogSearch } from "@/lib/use-dialog-search";
import { appRoute } from "./route";

const BudgetsPage = lazy(async () => {
  const m = await import("@/features/budgets/components/budgets-page");
  return { default: m.BudgetsPage };
});

function BudgetsPageWrapper() {
  return (
    <Suspense fallback={null}>
      <BudgetsPage />
    </Suspense>
  );
}

export const budgetsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/budgets",
  // Addressable create/edit dialogs: `?new=1` / `?edit=<budgetId>`.
  validateSearch: sanitizeDialogSearch,
  component: BudgetsPageWrapper,
});
